import { EditFieldBase } from './edit-field-base.model';
import { EditFieldControlTypeEnum } from './edit-field-control-type.enum.model';

export class EditFieldNumeric extends EditFieldBase<string> {
    controlType = EditFieldControlTypeEnum.Numeric;
}
